import React, {
  PropsWithChildren,
  useCallback,
  useEffect,
  useState
} from 'react'

import { defaultTheme as theme, Theme } from '@/constants/theme'
import { ThemeProviderContext } from '@/hooks/useTheme'

type ThemeProviderProps = {
  children: React.ReactNode
  defaultTheme?: Theme
  storageKey?: string
}

const ThemeProvider: React.FC<PropsWithChildren<ThemeProviderProps>> = ({
  children,
  defaultTheme = theme,
  storageKey = 'theme',
  ...props
}) => {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem(storageKey) as Theme) || defaultTheme
  )

  const handleTheme = useCallback(
    (theme: Theme) => {
      localStorage.setItem(storageKey, theme)
      setTheme(theme)
    },
    [storageKey]
  )

  useEffect(() => {
    const root = window.document.documentElement

    root.classList.remove(Theme.Light, Theme.Dark)

    // if (theme === Theme.System) {
    //   const systemTheme = window.matchMedia('(prefers-color-scheme: dark)')
    //     .matches
    //     ? 'dark'
    //     : 'light'

    //   root.classList.add(systemTheme)
    //   return
    // } else {
    //   setThemeMode(theme)
    // }

    root.classList.add(theme)
  }, [theme])

  return (
    <ThemeProviderContext.Provider
      {...props}
      value={{
        theme,
        setTheme: handleTheme
      }}
    >
      {children}
    </ThemeProviderContext.Provider>
  )
}

export default ThemeProvider
